import { render, staticRenderFns } from "./deviceMsgFooter.vue?vue&type=template&id=56690284&scoped=true&"
import script from "./deviceMsgFooter.vue?vue&type=script&lang=js&"
export * from "./deviceMsgFooter.vue?vue&type=script&lang=js&"
import style0 from "./deviceMsgFooter.vue?vue&type=style&index=0&id=56690284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56690284",
  null
  
)

export default component.exports